$(function() {
    
    $(".lm-other-interests-container").on("click", ".accordion-trigger", function() {
        $(this).parent(".accordion-block").toggleClass("open");
        $(this).siblings(".content-wrapper").slideToggle();
    })

    if ($("html").hasClass("phone")) {
        // handle moving the "search form" to the bottom of the page in responsive mode.
        const searchForm = $("#lm-spec-search-wrapper-seo").detach();
        searchForm.insertAfter(".lm-supplier-datasheets-other-links-container .supplier-datasheets");

        // dynamically size tables down for responsive on learn more pages
        if ($("html").hasClass("lm") && $("html").hasClass("phone")) {
            fixLargeTables();
        }
    } else {
        if ($('#lm-spec-search-wrapper-seo').length) {
            const headerHeight = $("#header-content").height()
            let currentPosition = 0;
            const navColumnTopOffset = $("#navigation").offset().top - headerHeight;
            const viewportHeight = window.innerHeight - headerHeight - 30;
            let footerPosition = $("#footer-wrapper").offset().top;
            let viewportBottom = $(window).scrollTop() + $(window).innerHeight();
            let sizeOfFooterInView = viewportBottom - footerPosition;

            positionNavColumn();
            $(window).on("scroll", function () {
             positionNavColumn();
            })

            function positionNavColumn() {
             currentPosition = $(window).scrollTop();
             footerPosition = $("#footer-wrapper").offset().top;
             viewportBottom = $(window).scrollTop() + $(window).innerHeight();
             sizeOfFooterInView = viewportBottom - footerPosition + 10;

             let navHeight = viewportHeight;
             if (currentPosition > navColumnTopOffset) {
                 // We don't want the nav to overlap the footer. So we'll adjust the height
                 // based on how much of the filter is in view.
                 if (viewportBottom > footerPosition) {
                     navHeight = viewportHeight - sizeOfFooterInView;
                 }
                 $(".learnmore-search-form").addClass("stick").css("height", navHeight + "px");
             } else {
                 $(".learnmore-search-form").removeClass("stick");
             }
            }

            $(".learnmore-search-form")
             .on("mouseenter", function () {
                 $(".learnmore-search-form").addClass("scroll");
             })
             .on("mouseleave", function () {
                 $(".learnmore-search-form").removeClass("scroll").scrollTop(0);
             });
        }
    }
});

/***************************************** HELPER FUNCTIONS *****************************************/

function fixLargeTables() {
    $("#main-content").find("table").each(function() {
        const tableWidth = $(this).width();
        const parentWidth = $(this).parent().width();

        if (tableWidth > parentWidth) {
            const zoomFactor = parentWidth / tableWidth;
            $(this).css("zoom", zoomFactor);
        }
    });
}